import { Editor } from "@tinymce/tinymce-react";
import { useState } from "react";

export function DommusRichTextEditor({onEditorChange, value, init=null, defaultValue, height, ref, disabled=false}){
  const initValues = init ?? {
          height: height ?? 200,
          menubar: false,
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
          ],
          toolbar: 'undo redo | blocks | image | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'media | removeformat | code | help',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
  }

  return (
    <>
      <Editor
        ref={ref}
        tinymceScriptSrc='/tinymce/tinymce.min.js'
        licenseKey='gpl'
        onChange={(event)=>{
          onEditorChange(event?.target?.getContent() ?? "");
        }}
        initialValue={value}
        init={initValues}
        disabled={disabled}
      />
    </>
  );}
